export default __webpack_public_path__ + "static/media/illustration-mian-w@3x.073a63d9.png";